<template>
    <div class="add-entity-button" :class="{open:menuOpen}">
        <ul class="elements">
            <li @click="addEntity('direct')">{{$t('main.newSale')}}   <img src="@/assets/NewSale.svg"/></li>
            <li @click="addEntity('customer')">{{$t('main.newCust')}}   <img src="@/assets/NewCust.svg"/></li>
            <li @click="addEntity('party')">{{$t('main.newParty')}}  <img src="@/assets/NewParty.svg"/></li>
        </ul>
        <div class="toggler" @click="toggleMenu">
            <img src="@/assets/AddNewEntity.svg">
        </div>

    </div>
</template>

<script>
    import {ref} from 'vue'

    export default {
        name: "AddEntityButton",
        methods:{
            addEntity(addableType){
                this.$emit('add-component-clicked', addableType)
            }
        },
        setup(){
            const menuOpen = ref(false)
            const addEntityOpen = ref(false)
            const toggleMenu = () =>{
                menuOpen.value = !menuOpen.value
            }



            return {
                menuOpen,
                addEntityOpen,
                toggleMenu
            }
        }

    }
</script>

<style scoped>

</style>
